import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-36 overflow-hidden">
      {/* Background */}
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20warm%20atmospheric%20Korean%20manhwa%20style%20background%2C%20open%20book%20with%20glowing%20pages%2C%20magical%20particles%20floating%2C%20reading%20in%20darkness%20theme%2C%20rich%20dark%20red%20and%20black%20tones%2C%20cinematic%20lighting%2C%20mysterious%20and%20inviting%20mood%2C%20illustration%20style%20with%20soft%20glow&width=1600&height=700&seq=cta-bg-2026-home&orientation=landscape"
        alt="韩漫阅读"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50/90" />

      {/* Content */}
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-50 tracking-wide mb-6">
          开启你的韩漫之旅
        </h2>
        <p className="text-foreground-300 text-sm md:text-base max-w-xl mx-auto leading-relaxed mb-4">
          无需注册，即刻畅读上千部精选韩漫
        </p>
        <p className="text-foreground-400 text-sm max-w-xl mx-auto leading-relaxed mb-10">
          无遮挡下拉式体验，沉浸故事不中断
        </p>

        <Link
          to="/category/action"
          className="inline-flex items-center gap-3 px-8 py-4 bg-background-950 text-foreground-50 rounded-full text-sm font-semibold hover:bg-background-900 transition-all whitespace-nowrap cursor-pointer"
        >
          <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-sm"></i>
          </span>
          立即免费阅读
          <i className="ri-arrow-right-up-line text-lg"></i>
        </Link>
      </div>
    </section>
  );
}